var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cta-button',_vm._g(_vm._b({staticClass:"icon-button no-outline badge--equal-padding",attrs:{"aria-label":_vm.ariaLabel,"is-solid":_vm.isSolid}},'cta-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }